module.exports = __webpack_public_path__ + "img/5.417a28e9.png";